import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { InspirationRoomService } from "../../canvas/services/inspiration-rooms/inspiration-room.service";
import { InspirationGroup } from "../../models/InspirationGroupModel";
import { InspirationRoomModel } from "../../models/InspirationRoomModel";
import { Globals } from "../../services/globals";
import { InspirationGroupService } from "../../services/inspiration-group.service";




@Component({
  selector: "inspiration",
  templateUrl: "inspiration.component.html",
  styleUrls: ["inspiration.component.css"]
})

export class InspirationComponent {

  allRooms: InspirationRoomModel[] = [];
  allAreas: string[] = [];
  inspirationGroup: InspirationGroup[];
  inspirationGroupList: any;
  filteredGroupList: InspirationGroup[];
  currentGroupRooms: any;
  title: string;

  constructor(public globals: Globals,
    private inspirationRoom: InspirationRoomService,
    private router: Router,
    private inspirationGroupService: InspirationGroupService,
  ) {
    // These need to come from a configuration
    this.globals.hideHeader = true;
  }

  ngOnInit() {
    this.globals.previousSelectedArea = 0;
    if (this.globals.allRooms && this.globals.allRooms.length) {
      this.allRooms = JSON.parse(JSON.stringify(this.globals.allRooms));
      this.initRooms()
    } else {
      this.inspirationRoom.listInspirationRooms().subscribe(response => {
        this.allRooms = response;
        this.globals.allRooms = JSON.parse(JSON.stringify(this.allRooms));
        this.initRooms()
      });
    }
  }

  initRooms() {
    this.filterRooms();
    if (this.globals.roomGroupId) {
      this.showAllRooms(this.globals.roomGroupId);
    }
  }

  filterRooms() {
    if (this.globals.engine === undefined) {
      requestAnimationFrame(() => this.filterRooms());
    }
    else {

      const availableOptionIds = this.globals.engine.allOptionAndStyleIds();

      if (availableOptionIds && this.allRooms.length) {
        this.allRooms.forEach(room => {
          room.options = room.options.filter(function (option) {
            return availableOptionIds.filter(function (optionId) {
              return optionId === option.optionId;
            }).length;
          });
        });
        this.allRooms = this.allRooms.filter(room => room.options.length > 0);
        this.getInspirationGroups();
      }
    }
  }

  openInspirationRoomForOption(room: number) {
    this.router.navigate(['/inspirationRoomSelection/' + room]);
  }

  //getFormattedUrl(url: string): string {

  //  return `url(${url})`;
  //}


  getInspirationGroups() {
    this.filteredGroupList = [];
    this.inspirationGroupService.getInspirationGroups().subscribe(inspirationGroup => {
      this.inspirationGroup = inspirationGroup;
      this.inspirationGroup.forEach(group => {
        const roomExist = this.roomsByGroup(group.id);
        if (roomExist) {
          this.filteredGroupList.push(group);

        }
      });
    });
  }

  getThumbnailUrl(index: number, groupId) {
    const rooms = this.allRooms.filter(x => x.inspirationGroupId === groupId);
    let url = rooms[index]?.thumbnailUrl;
    if (!url) {
      url = rooms[0]?.thumbnailUrl;
    }
    return url;
  }

  getRoomsCount(groupId) {
    let count = 0;
    const rooms = this.allRooms.filter(x => x.inspirationGroupId === groupId);
    count = rooms.length;
    return count;
  }


  roomsByGroup(groupId: number) {
    return this.allRooms.find(x => x.inspirationGroupId === groupId);
  }


  showAllRooms(groupId: number) {
    this.globals.roomGroupId = groupId;
    this.globals.showRoomGroupings = !this.globals.showRoomGroupings;
    this.currentGroupRooms = this.allRooms.filter(x => x.inspirationGroupId === groupId);
    this.currentGroupRooms.sort((a, b) => {
      // If a.displayOrder is 0 and b.displayOrder is not 0, place b before a
      if (a.displayOrder === 0 && b.displayOrder !== 0) {
        return 1;
      }
      // If b.displayOrder is 0 and a.displayOrder is not 0, place a before b
      else if (b.displayOrder === 0 && a.displayOrder !== 0) {
        return -1;
      }
      // Otherwise, sort by displayOrder ascending
      else {
        return a.displayOrder - b.displayOrder;
      }
    });

    this.title = this.currentGroupRooms[0].inspirationGroup.name;
  }


  //getSubGroupName(roomId: number, subGroupId: number) {
  //  if (subGroupId > 0) {
  //    let room = this.currentGroupRooms.find(x => x.id === roomId);
  //    return room?.inspirationGroup?.inspirationSubGroups?.find(x => x.id === subGroupId).name;

  //  }
  //  return "";
  //}
}
